import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'
import store from "@/store/store.js"

export default {
    fetch(chatTicketId = undefined, transferred = undefined) {
        store.dispatch('setShowLoadingOverlay', false);
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                query {
                    ticketTransfer (
                        ` + (chatTicketId === undefined ? '' : `chat_ticket_id: ${chatTicketId},`) + `,
                        ` + (transferred === undefined ? '' : `transferred: ${transferred},`) + `
                    ) {
                        id,
                        transfer_at,
                        created_at,
                        transferred_at,
                        chatTicket {
                            id
                        },
                        previousUser {
                            id,
                            name
                        },
                        nextUser {
                            id,
                            name
                        }
                    }
                }
            `
       })
    },
    fetchByCustomerId(customerId, paginationPage, paginationLimit, orderBy = 'DESC') {
        store.dispatch('setShowLoadingOverlay', false);
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                query {
                    ticketTransferByCustomerId (
                        customer_id: ${customerId},
                        pagination_page: ${paginationPage},
                        pagination_limit: ${paginationLimit},
                        order_by: "${orderBy}"
                    ) {
                        pagination_page,
                        pagination_limit,
                        total_pages,
                        total_items,
                        items {
                            id,
                            pulled,
                            transferred_at,
                            userDepartment {
                                id,
                                name
                            },
                            previousUser {
                                id,
                                name,
                                image
                            },
                            nextUser {
                                id,
                                name,
                                image
                            }
                        }
                    }
                }
            `
       })
    },
    add(nextUserId, previousUserId, chatTicketId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                mutation {
                    createTicketTransfer (
                        next_user_id: ` + nextUserId + `,
                        previous_user_id: ` + previousUserId + `,
                        chat_ticket_id: ` + chatTicketId + `
                    ) {
                        id,
                        transfer_at,
                        created_at,
                        transferred_at,
                        chatTicket {
                            id
                        },
                        previousUser {
                            id,
                            name
                        },
                        nextUser {
                            id,
                            name
                        }
                    }
                }
            `
        })
    },
    confirmTicketTransfer(ticketTransferId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                mutation {
                    confirmTicketTransfer (
                        id: ` + ticketTransferId + `
                    )
                }
            `
        })
    },
    deleteTicketTransfer(ticketTransferId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                mutation {
                    deleteTicketTransfer (
                        id: ` + ticketTransferId + `
                    )
                }
            `
        })
    }
}
